import { h } from 'preact';
import { ArticleSurvey } from 'core_main/api/knowledge_bases/types';
import Checkbox from 'widget_main/components/Checkbox';
import styles from './kbArticleSurveyFeedbackSuggestedReasons.scss';

export interface KBArticleSurveyFeedbackSuggestedReasonsProps {
  enabled: boolean;
  title: ArticleSurvey['suggestedReasonsTitle'];
  suggestedReasons: ArticleSurvey['suggestedReasons'];
  suggestedReasonsChecked: Record<string, boolean>;
  onClick: (checked: boolean, value?: string) => void;
}
const KBArticleSurveyFeedbackSuggestedReasons = ({
  enabled,
  suggestedReasons,
  suggestedReasonsChecked,
  title,
  onClick,
}: KBArticleSurveyFeedbackSuggestedReasonsProps) => {
  const renderCheckbox = ({ value, displayText }) => {
    return (
      <Checkbox
        name={value}
        ariaLabel={displayText}
        label={displayText}
        value={value}
        checked={!!suggestedReasonsChecked[value]}
        onClick={onClick}
      />
    );
  };
  if (!enabled) return null;
  return (
    <div>
      <label
        for="suggestedReasons"
        className={styles.articleSurveySuggestedReasonsLabel}
      >
        {title}
      </label>
      {suggestedReasons.map(({ value, displayText }) =>
        renderCheckbox({ value, displayText }),
      )}
    </div>
  );
};

export default KBArticleSurveyFeedbackSuggestedReasons;
